import { render, staticRenderFns } from "./WorkData.vue?vue&type=template&id=2eab9844&scoped=true"
import script from "./WorkData.vue?vue&type=script&lang=ts"
export * from "./WorkData.vue?vue&type=script&lang=ts"
import style0 from "./WorkData.vue?vue&type=style&index=0&id=2eab9844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eab9844",
  null
  
)

export default component.exports